import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-dark-navy text-white py-16 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div>
            <h3 className="text-2xl font-bold mb-4">North</h3>
            <p className="text-gray-400 leading-relaxed mb-6">
              Fractional CTO & Technology Consulting services for modern enterprises.
            </p>
            <motion.a
              href="https://calendar.app.google/ube4SfQSbn6SqRCCA"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-6 py-3 bg-white text-dark-navy rounded-full font-semibold hover:bg-gray-100 transition-all inline-block"
            >
              Get Started
            </motion.a>
          </div>

          {/* Services Column */}
          <div>
            <h4 className="font-bold text-lg mb-4">
              <Link to="/services" className="hover:text-gray-200 transition-colors">Services</Link>
            </h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Fractional CTO
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  AI & Agentic Implementation
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Cloud Native Development
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Data & Analytics
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-white transition-colors">
                  Security & DevOps
                </Link>
              </li>
            </ul>
          </div>

          {/* Company & Regions Column */}
          <div>
            <h4 className="font-bold text-lg mb-4">Company</h4>
            <ul className="space-y-3 text-gray-400">
              <li>
                <Link to="/about" className="hover:text-white transition-colors">
                  About North
                </Link>
              </li>
              <li>
                <Link to="/solutions" className="hover:text-white transition-colors">
                  Solutions
                </Link>
              </li>
              <li>
                <Link to="/blog" className="hover:text-white transition-colors">
                  Blog
                </Link>
              </li>
              <li className="pt-2">
                <span className="text-gray-500 text-xs font-medium uppercase tracking-wider">Regions</span>
              </li>
              <li>
                <Link to="/calgary" className="hover:text-white transition-colors">
                  Calgary & Alberta
                </Link>
              </li>
              <li>
                <Link to="/vancouver" className="hover:text-white transition-colors">
                  Vancouver & BC
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column */}
          <div>
            <h4 className="font-bold text-lg mb-4">Let's Connect</h4>
            <p className="text-gray-400 mb-4">
              Ready to elevate your technology strategy?
            </p>
            <div className="space-y-3">
              <a
                href="mailto:info@northinteractive.co"
                className="flex items-center text-gray-400 hover:text-white transition-colors"
              >
                <svg className="w-5 h-5 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                info@northinteractive.co
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center text-gray-400 text-sm">
          <p>&copy; {currentYear} North. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0">
            <span className="hover:text-white transition-colors cursor-pointer">Privacy Policy</span>
            <span className="hover:text-white transition-colors cursor-pointer">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
